'use client';

import { AKLAMIO_NAME } from '@lichtblick/consent/ConsentManager/ConsentManager.types';
import { useConsent } from '@lichtblick/consent/hooks/useConsent';
import type { FC, ReactNode } from 'react';

type OptionSwitcherProps = { disabled: ReactNode; enabled: ReactNode };

export const OptinSwitcher: FC<OptionSwitcherProps> = ({ disabled, enabled }) => {
  const consentState = useConsent(AKLAMIO_NAME);

  return consentState ? enabled : disabled;
};
